import { render, staticRenderFns } from "./statusInfo.vue?vue&type=template&id=359ce490&scoped=true&"
import script from "./statusInfo.vue?vue&type=script&lang=js&"
export * from "./statusInfo.vue?vue&type=script&lang=js&"
import style0 from "./statusInfo.vue?vue&type=style&index=0&id=359ce490&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359ce490",
  null
  
)

export default component.exports